import React from "react";
import {
  CriticalIcon as Critical,
  InfoIcon as Information,
  SuccessIcon,
  NormalIcon as Normal
} from "../Icons";
import { ToastIconProps, ToastVariant } from "./Toast.types";
import { Icon as StyledIcon } from "./Icon.styles";

const getIcon = (variant: ToastIconProps["variant"]) => {
  switch (variant) {
    case ToastVariant.warning:
      return <Normal color="var(--theme-warning-600)" />;
    case ToastVariant.success:
      return <SuccessIcon color="var(--theme-success-600)" />;
    case ToastVariant.error:
      return <Critical />;
    case ToastVariant.information:
    default:
      return <Information color="var(--theme-graph-900)" />;
  }
};

/**
 * Convenient way to identify the Toast variant
 */
export const Icon = ({
  variant = ToastVariant.information
}: ToastIconProps) => <StyledIcon>{getIcon(variant)}</StyledIcon>;
